export function normalizeError(error) {
  if (error instanceof Error) return error.message;
  return 'Failed to process request.';
}

export async function adminRequest(token, url, { onUnauthorized, ...options } = {}) {
  const headers = {
    Authorization: `Bearer ${token}`,
    ...(options.body ? { 'Content-Type': 'application/json' } : {}),
    ...(options.headers || {}),
  };

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401 || response.status === 403) {
    if (onUnauthorized) onUnauthorized();
    throw new Error('Session expired or invalid.');
  }

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || `Request failed with status ${response.status}`);
  }

  if (response.status === 204) return null;
  return response.json();
}
